import {
	Wrapper as MapsWrapper,
	Status,
	WrapperProps as MapsWrapperProps,
} from '@googlemaps/react-wrapper';
import type { ReactElement } from 'react';
import type { LocationSelectProps } from './location-select.types';
import logger from '../utils/logger';

type ModifiedMapsWrapperProps = Omit<
	MapsWrapperProps,
	'children' | 'render' | 'apiKey'
>;

export type WrapperProps = ModifiedMapsWrapperProps & {
	disableMapsLoading?: boolean;
	render: NonNullable<MapsWrapperProps['render']>;
	apiKey: LocationSelectProps['googleMapsAPIKey'];
};

export const Wrapper = ({
	disableMapsLoading,
	render,
	apiKey,
	...wrapperProps
}: WrapperProps): ReactElement => {
	if (!apiKey) {
		logger.warn('[LocationSelect]', 'Missing googleMapsAPIKey prop');
	}

	if (!apiKey || disableMapsLoading) {
		return render(Status.SUCCESS);
	}

	return <MapsWrapper {...wrapperProps} apiKey={apiKey} render={render} />;
};
